"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledItemNameContainer = exports.StyledFilterLabel = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _iconsReact = require("../../icons-react");

var _pluralizeUtils = require("../../utils/pluralizeUtils");

var _CurrencyFormat = _interopRequireDefault(require("../CurrencyFormat"));

var _Bubble = _interopRequireDefault(require("../Bubble"));

var _Bubble2 = require("../Bubble/Bubble");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FilterLabel = function FilterLabel(_ref) {
  var _ref$count = _ref.count,
      count = _ref$count === void 0 ? 0 : _ref$count,
      price = _ref.price,
      currencyCode = _ref.currencyCode,
      name = _ref.name,
      _ref$emptyMessage = _ref.emptyMessage,
      emptyMessage = _ref$emptyMessage === void 0 ? 'нет отелей' : _ref$emptyMessage,
      description = _ref.description,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$subjectToPlural = _ref.subjectToPlural,
      subjectToPlural = _ref$subjectToPlural === void 0 ? 'HOTELS' : _ref$subjectToPlural;
  var hasOffersCount = count > 0;
  var showOffersCount = hasOffersCount && (!disabled || disabled && selected);
  return /*#__PURE__*/_react["default"].createElement(StyledFilterLabel, {
    className: className,
    disabled: disabled,
    selected: selected,
    isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(StyledItemNameContainer, null, /*#__PURE__*/_react["default"].createElement(StyledItemName, null, name, description && !isMobile ? /*#__PURE__*/_react["default"].createElement(StyledBubble, {
    text: description
  }, /*#__PURE__*/_react["default"].createElement(QuestionIcon, null)) : null)), /*#__PURE__*/_react["default"].createElement(StyledItemInfo, null, showOffersCount ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "".concat(count, " ").concat((0, _pluralizeUtils.pluralizeBySubject)(count, subjectToPlural)), /*#__PURE__*/_react["default"].createElement(_CurrencyFormat["default"], {
    value: price,
    currencyCode: currencyCode,
    prefix: " \u043E\u0442 "
  })) : emptyMessage));
};

var StyledBubble = (0, _styledComponents["default"])(_Bubble["default"]).withConfig({
  displayName: "FilterLabel__StyledBubble",
  componentId: "sc-g9k756-0"
})(["display:inline;vertical-align:middle;margin-left:4px;", "{display:inline;}"], _Bubble2.InnerWrapper);
var QuestionIcon = (0, _styledComponents["default"])(_iconsReact.QuickTipWhite).withConfig({
  displayName: "FilterLabel__QuestionIcon",
  componentId: "sc-g9k756-1"
})(["display:inline;width:16px;height:16px;"]);

var StyledItemNameContainer = _styledComponents["default"].div.withConfig({
  displayName: "FilterLabel__StyledItemNameContainer",
  componentId: "sc-g9k756-2"
})(["display:flex;"]);

exports.StyledItemNameContainer = StyledItemNameContainer;

var StyledItemName = _styledComponents["default"].div.withConfig({
  displayName: "FilterLabel__StyledItemName",
  componentId: "sc-g9k756-3"
})(["overflow:hidden;text-overflow:ellipsis;"]);

var StyledItemInfo = _styledComponents["default"].div.withConfig({
  displayName: "FilterLabel__StyledItemInfo",
  componentId: "sc-g9k756-4"
})([""]);

var StyledFilterLabel = _styledComponents["default"].div.withConfig({
  displayName: "FilterLabel__StyledFilterLabel",
  componentId: "sc-g9k756-5"
})(["overflow:hidden;width:100%;font-size:", "px;", " ", " ", "{font-size:", "px;color:", ";}"], function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? 17 : 14;
}, function (_ref3) {
  var theme = _ref3.theme,
      disabled = _ref3.disabled,
      selected = _ref3.selected;
  return !disabled && (0, _styledComponents.css)(["color:", ";&:hover{color:", ";}"], selected ? theme.colors.black : theme.colors.blackLight, theme.colors.black);
}, function (_ref4) {
  var theme = _ref4.theme,
      disabled = _ref4.disabled;
  return disabled && (0, _styledComponents.css)(["color:", ";"], theme.colors.greyLight);
}, StyledItemInfo, function (_ref5) {
  var isMobile = _ref5.isMobile;
  return isMobile ? 13 : 12;
}, function (_ref6) {
  var selected = _ref6.selected,
      disabled = _ref6.disabled,
      theme = _ref6.theme;
  return selected || disabled ? 'inherit' : theme.colors.greyLight;
});

exports.StyledFilterLabel = StyledFilterLabel;

var _default = /*#__PURE__*/_react["default"].memo(FilterLabel);

exports["default"] = _default;